var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-not-found"},[_c('van-empty',{attrs:{"image":"network","description":"页面不存在"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }